import request from '@/utils/request'

export const permissionAPI = (params) => {
  return request({
    url: '/permission ',
    method: 'GET',
    params
  })
}
